import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import { messageSlice, rtkQueryErrorLogger } from "../features/message";
import { inbusSplitApi } from "../api/inbusApi";

export const store = configureStore({
  reducer: {
    // Add the generated reducer as a specific top-level slice
    [inbusSplitApi.reducerPath]: inbusSplitApi.reducer,

    message: messageSlice.reducer,
  },
  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(inbusSplitApi.middleware).concat(rtkQueryErrorLogger),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
